/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DiscrepanciesChoices } from '../../models/discrepancies-choices';

export interface GetDiscrepanciesChoices$Params {
}

export function getDiscrepanciesChoices(http: HttpClient, rootUrl: string, params?: GetDiscrepanciesChoices$Params, context?: HttpContext): Observable<StrictHttpResponse<DiscrepanciesChoices>> {
  const rb = new RequestBuilder(rootUrl, getDiscrepanciesChoices.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DiscrepanciesChoices>;
    })
  );
}

getDiscrepanciesChoices.PATH = '/discrepancies/choices';
